import { Configuration, PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';

export const redirectUri = window.location.origin;

export const IS_DEV = process.env.REACT_APP_DEV;

let dynamicConfig = {
    REACT_APP_TCMS_BASE_API_URL: '',
    REACT_APP_TCMS_API_URL: '',
    REACT_APP_TENANT: '',
    REACT_APP_TCMS_CLIENT_ID: '',
    REACT_APP_PMS_CLIENT_ID: ''
};

export const msal = {
    config: {} as Configuration,
    instance: {} as IPublicClientApplication,
    scopes: [] as string[],
    dynamicConfig: dynamicConfig
};

export default (async () => {
    const response = await fetch(`${window.location.origin}/dynamic-configs/config.json`, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    });

    const json = await response.json();

    const config: Configuration = {
        auth: {
            authority: json.REACT_APP_ADAL_INSTANCE + json.REACT_APP_TENANT,
            clientId: json.REACT_APP_TCMS_CLIENT_ID,
            redirectUri: redirectUri,
            postLogoutRedirectUri: redirectUri,
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false
        }
    };

    msal.dynamicConfig = json;

    if (!process.env.REACT_APP_DEV) {
        msal.config = config;
        msal.scopes = [json.REACT_APP_TCMS_CLIENT_ID + '/.default'];
        msal.instance = new PublicClientApplication(msal.config);
    }
})();
